const money = (n) => `$${(Number(n) || 0).toFixed(2)}`;

export const QuoteBreakdown = ({ estimate }) => {
  const items = (estimate.line_items || []).filter((i) => (i.quantity || 0) > 0);
  const discount = Number(estimate.discount_amount) || 0;
  const tax = Number(estimate.tax) || 0;
  return (
    <div className="bg-zinc-50 rounded-xl p-4 mb-6" data-testid="booked-quote-summary">
      <h3 className="font-semibold text-zinc-700 mb-3">Quote Summary</h3>
      {items.length > 0 && (
        <div className="space-y-2 mb-3">
          {items.map((item, i) => (
            <div key={i} className="flex justify-between gap-3 text-sm" data-testid={`booked-quote-line-${i}`}>
              <span className="text-zinc-700">
                {item.name}
                <span className="text-zinc-400"> × {Number(item.quantity)}</span>
              </span>
              <span className="font-medium text-zinc-900 tabular-nums">
                {money(item.line_total ?? item.quantity * (item.unit_price || 0))}
              </span>
            </div>
          ))}
        </div>
      )}
      {items.length > 0 && (
        <div className="border-t border-zinc-200 pt-2 space-y-1 text-sm">
          {estimate.subtotal != null && (
            <div className="flex justify-between text-zinc-600">
              <span>Subtotal</span><span className="tabular-nums">{money(estimate.subtotal)}</span>
            </div>
          )}
          {discount > 0 && (
            <div className="flex justify-between text-green-700" data-testid="booked-quote-discount">
              <span>Discount</span><span className="tabular-nums">−{money(discount)}</span>
            </div>
          )}
          {tax > 0 && (
            <div className="flex justify-between text-zinc-600">
              <span>Tax</span><span className="tabular-nums">{money(tax)}</span>
            </div>
          )}
        </div>
      )}
      <div className={`flex justify-between items-baseline ${items.length ? "mt-2 pt-2 border-t border-zinc-200" : ""}`}>
        <span className="font-semibold text-zinc-800">Total</span>
        <span className="text-2xl font-bold text-[#207024]" data-testid="booked-quote-total">{money(estimate.total)}</span>
      </div>
    </div>
  );
};
